import { render, staticRenderFns } from "./InputSenha.vue?vue&type=template&id=fd0805a2"
import script from "./InputSenha.vue?vue&type=script&lang=js"
export * from "./InputSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports